import { Activity, ListChecks } from 'lucide-react';
import type { ReactNode } from 'react';

/** 수행 데이터 없을 때 — 레이아웃만 유지 */
export function ResultSectionDashedEmpty({ message, className = '' }: { message: string; className?: string }) {
  return (
    <div
      className={`rounded-xl border border-dashed border-slate-200/90 bg-white px-4 py-10 sm:py-12 text-center text-sm text-slate-600 ${className}`.trim()}
      role="status"
    >
      {message}
    </div>
  );
}

const leadByVariant = {
  /** 루브릭/체크리스트 등 */
  list: { Icon: ListChecks, box: 'bg-slate-200/60 border-slate-200/80', fg: 'text-slate-600' },
  /** 절차·IV 등 수행 블록(스켈레톤) */
  activity: { Icon: Activity, box: 'bg-sky-200/55 border-sky-200/80', fg: 'text-sky-800' },
} as const;

type LeadVariant = keyof typeof leadByVariant;

/** GCS/절차형 등 `수행결과` 제목 + 아이콘 — 본문은 `children` */
export function ResultSectionWithTitle({
  title,
  children,
  lead = 'list',
}: {
  title: string;
  children: ReactNode;
  lead?: LeadVariant;
}): React.ReactElement {
  const { Icon, box, fg } = leadByVariant[lead];
  return (
    <div className="space-y-4 !mt-6 !mb-4">
      <h3 className="text-lg md:text-xl font-bold text-gray-900 flex items-center gap-2.5 min-w-0">
        <div
          className={`w-9 h-9 flex items-center justify-center rounded-lg border shrink-0 ${box}`}
        >
          <Icon size={20} className={fg} />
        </div>
        <span className="truncate min-w-0">{title}</span>
      </h3>
      {children}
    </div>
  );
}
